/* Angular */
import { createReducer, on } from '@ngrx/store';

/* Functions */
import { updateEntityInArray } from 'src/app/features/shared/functions';

/* actions */
import * as DailyProgramItemDataStoreActions from './daily-program-item-data-store.actions';

import { DailyProgramItem } from 'src/app/features/shared/models';

/* State key */
export const featureKey = 'DailyProgramItemDataStore';

/* State interface */
export interface DailyProgramItemState {
  isLoading?: boolean;
  activeDailyProgramItem?: DailyProgramItem;
  dailyProgramItems?: DailyProgramItem[];
}

/* Initial values */
export const initialState: DailyProgramItemState = {
  isLoading: null,
  activeDailyProgramItem: null,
  dailyProgramItems: null,
};

export const reducer = createReducer(
  initialState,
  on(
    DailyProgramItemDataStoreActions.GetDailyProgramItems,
    (state, action) => ({
      ...state,
      isLoading: true,
    }),
  ),

  on(
    DailyProgramItemDataStoreActions.GetDailyProgramItemsSuccessful,
    (state, action) => ({
      ...state,
      dailyProgramItems: action.payload.dailyProgramItems,
      isLoading: false,
    }),
  ),

  on(
    DailyProgramItemDataStoreActions.GetDailyProgramItemsFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(
    DailyProgramItemDataStoreActions.GetDailyProgramItemById,
    (state, action) => ({
      ...state,
      isLoading: true,
    }),
  ),

  on(
    DailyProgramItemDataStoreActions.GetDailyProgramItemByIdSuccessful,
    (state, action) => ({
      ...state,
      /* TODO: replace item by id from data array */
      isLoading: false,
    }),
  ),

  on(
    DailyProgramItemDataStoreActions.GetDailyProgramItemByIdFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(
    DailyProgramItemDataStoreActions.GetActiveDailyProgramItemWithRelationsById,
    (state, action) => ({
      ...state,
      isLoading: true,
    }),
  ),

  on(
    DailyProgramItemDataStoreActions.GetActiveDailyProgramItemByIdWithRelationsSuccessful,
    (state, action) => ({
      ...state,
      activeDailyProgramItem: action.payload.activeDailyProgramItem,
      isLoading: false,
    }),
  ),

  on(
    DailyProgramItemDataStoreActions.GetActiveDailyProgramItemByIdWithRelationsFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(
    DailyProgramItemDataStoreActions.CreateDailyProgramItem,
    (state, action) => ({
      ...state,
      isLoading: true,
    }),
  ),

  on(
    DailyProgramItemDataStoreActions.CreateDailyProgramItemSuccessful,
    (state, action) => ({
      ...state,
      dailyProgramItems: [
        ...(state.dailyProgramItems ?? []),
        action.payload.dailyProgramItem,
      ],
      isLoading: false,
    }),
  ),

  on(
    DailyProgramItemDataStoreActions.CreateDailyProgramItemFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(
    DailyProgramItemDataStoreActions.UpdateDailyProgramItem,
    (state, action) => ({
      ...state,
      isLoading: true,
    }),
  ),

  on(
    DailyProgramItemDataStoreActions.UpdateDailyProgramItemSuccessful,
    (state, action) => ({
      ...state,
      dailyProgramItems: updateEntityInArray<DailyProgramItem>(
        action.payload.id,
        action.payload.data,
        state.dailyProgramItems ?? [],
      ),
      isLoading: false,
    }),
  ),

  on(
    DailyProgramItemDataStoreActions.UpdateDailyProgramItemFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(
    DailyProgramItemDataStoreActions.DeleteDailyProgramItem,
    (state, action) => ({
      ...state,
      isLoading: true,
    }),
  ),

  on(
    DailyProgramItemDataStoreActions.DeleteDailyProgramItemSuccessful,
    (state, action) => ({
      ...state,
      dailyProgramItems:
        state.dailyProgramItems?.filter(
          (item) => action.payload.id !== item.id,
        ) ?? [],
      isLoading: false,
    }),
  ),

  on(
    DailyProgramItemDataStoreActions.DeleteDailyProgramItemFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(DailyProgramItemDataStoreActions.ResetState, () => initialState),
);
